// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".description[data-v-99cc68ca] {\n  margin-bottom: 20px;\n}\n[data-v-99cc68ca] .desc-label {\n  width: 120px;\n}", ""]);
// Exports
module.exports = exports;
